import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild
}                                                                                      from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}                  from 'rxjs';
import {Create, ObjectFactory}                                                         from 'ts-tooling';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                      from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridStatusColumnConfig
}                                                                                      from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                                                      from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                                      from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                                      from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridDetailsBaseConfig
}                                                                                      from '../../ap-dyngrids/config/details/ap-dyn-grid-details-base-config';
import {
  ApDynGridDetailsGridConfig
}                                                                                      from '../../ap-dyngrids/config/details/ap-dyn-grid-details-grid-config';
import {
  FieldStore
}                                                                                      from '../../stores/farm/field.store';
import {debounceTime, filter, map}                                                     from 'rxjs/operators';
import {
  CropRotationStore
}                                                                                      from '../../stores/farm/crop.rotation.store';
import {
  CropTypeStore
}                                                                                      from '../../stores/base-data/crop.types.store';
import {
  LanguageStore
}                                                                                      from '../../stores/translation/language.store';
import {
  CampaignYearStore
}                                                                                      from '../../stores/login/campaignyear.store';
import {ApGridPagerType, ApStatsType, IGridPagerData, MapViewCurrentMenu, MapViewMode} from '../../ap-interface';
import {
  MapViewStore
}                                                                                      from '../../stores/layout/mapview.store';
import {
  ApTranslationPipe
}                                                                                      from '../../translation/pipes/ap-translation.pipe';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData
} from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ApIcons
} from '../../ap-interface/enums/layout/ap-icons';
import {
  NFertilizationBurgerMenuComponent
} from '../../entry-components/burger-menu-entry-components/n-fertilization-burger-menu.component';
import {
  BurgerMenuStore
}                                                                                      from '../../stores/map/burger.menu.store';
import {
  SettingsStore
}                                                                                      from '../../stores/base-data/settings.store';
import {
  FormStore
}                                                                                      from '../../stores/layout/form.store';
import {
  ApNFertilizationPlanningEntryComponent
}                                                                                      from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-planning-entry.component';
import {
  ApDynComponentComponent
}                                                                                      from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  NFertilizationStore
}                                                                                      from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApNFertilizationComponentService
}                                                                                      from '../services/ap-n-fertilization-component.service';
import {
  ApUtilService
}                                                                                      from '../../ap-utils/service/ap-util.service';
import {
  ApShowPointsOnMapService
}                                                                                      from '../../ap-utils/service/ap-show-points-on-map.service';
import {
  ApDateService
}                                                                                      from '../../ap-core/services/ap-date-service';
import {
  ApTranslationService
}                                                                                      from '../../ap-utils/service/ap-translation.service';
import {
  CropApplicationStore
}                                                                                      from '../../stores/task-management/crop-application.store';
import {
  MapStore
}                                                                                      from '../../stores/map/map.store';
import {
  StatisticStore
}                                                                                      from '../../stores/statistic/statistic.store';
import {
  ApNFertilizationCommonService
}                                                                                      from '../services/ap-n-fertilization.common.service';
import {GetRoundNumericPipe}                                                           from '../../ap-utils';
import {
  ApTooltipContentService
}                                                                                      from '../../ap-utils/service/ap-tooltip-content.service';
import {
  ApGetCropService
}                                                                                      from '../../stores/services/ap-get-crop.service';
import {
  FieldMassEditAction
}                                                                                      from '../../field-management/components/field-overview.component';
import {
  ApDynformsConfigFieldset
}                                                                                      from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                                      from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsValidator
}                                                                                      from '../../ap-dynforms/ap-dynforms-validator';
import {Validators}                                                                    from '@angular/forms';
import {
  ApDynformsConfigPlaceholder
}                                                                                      from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  NotifyStore
}                                                                                      from '../../stores/dialog/notify.store';
import {
  INFertilizationOverviewGridDetailsItem,
  NFertilizationOverviewMassEditAction
}                                                                                      from '../types/n-fertilization-overview.types';
import {
  BasicFertilisationSummariesStore
}                                                                                      from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {
  JobsStore
}                                                                                      from '../../stores/administration/jobs.store';
import {
  AgriportConstantsService
}                                                                                      from '../../services/common/agriport-constants.service';
import {
  NFertilizationLogfileStatsData
}                                                                                      from '../../statistics/components/charts/n-fertilization-logfile-stats/n-fertilization-logfile-stats.types';
import {
  PlanningEntryComponentDataType
}                                                                                      from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {
  ApRoleTypeService
}                                                                                      from '../../services/common/ap-role-type.service';
import {
  LoginStore
}                                                                                      from '../../stores/login/login.store';
import {
  GetRoundNumericPipeConfig
}                                                                                      from '../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import IFieldCrop = Data.FieldManagement.IFieldCrop;
import IGuid = System.IGuid;

/**
 * Component for the n fertilization overview
 */
@Component({
  selector: 'ap-n-fertilization-overview',
  template: `
    <ap-dyncomponent [caption]="'Admin_Pages__Overview'"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [loading$]="loading$"
                     [columns]="columns$ | async"
                     [details]="details$ | async"
                     [items]="items$ | async"
                     [pager]="pager"
                     [canSearch]="true"
                     [canCreate]="isCreateNewAllowed()"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApNFertilizationOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;

  public loading$: Observable<boolean> = of(true);
  public columns$: Observable<ApDynGridColumnConfigBase[]>;
  public details$: Observable<ApDynGridDetailsBaseConfig>;
  public items$ = new BehaviorSubject<any[]>([]);
  public pager: ApDynGridPagerConfig;
  public halfViewMode$ = new BehaviorSubject<number>(0);
  public halfViewModeChange = new EventEmitter<void>();

  private _applyClicked = new EventEmitter<any>();
  private _subscriptions: Subscription[] = [];
  private _afterUpdateProcess = false;

  constructor(private jobsStore: JobsStore,
              private burgerMenuStore: BurgerMenuStore,
              private campaignYear: CampaignYearStore,
              private cropApplicationStore: CropApplicationStore,
              private cropRotationStore: CropRotationStore,
              private cropTypeStore: CropTypeStore,
              private dateService: ApDateService,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private notifyStore: NotifyStore,
              private languageStore: LanguageStore,
              private mapStore: MapStore,
              private mapViewStore: MapViewStore,
              private settingsStore: SettingsStore,
              private statisticStore: StatisticStore,
              private nFertilizationStore: NFertilizationStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private showPointsOnMap: ApShowPointsOnMapService,
              private translationService: ApTranslationService,
              private cropService: ApGetCropService,
              private componentService: ApNFertilizationComponentService,
              private nFertilizationCommonService: ApNFertilizationCommonService,
              private tooltipContentService: ApTooltipContentService,
              private agriportConstantsService: AgriportConstantsService,
              private translationPipe: ApTranslationPipe,
              private roundNumericPipe: GetRoundNumericPipe,
              private loginStore: LoginStore) {
  }

  public ngOnInit(): void {
    this._subscriptions.push(this.halfViewModeChange.subscribe(() => {
      if (this.halfViewMode$.value) {
        this.halfViewMode$.next(0);
      } else {
        this.halfViewMode$.next(1);
      }
    }));
    this._subscriptions.push(combineLatest([
      this.campaignYear.Listen(s => s.selectedYear),
      this.jobsStore.FinishedNFertJobs$
    ]).pipe(debounceTime(100)).subscribe(() => {
      this.showPointsOnMap.clear();
      this.nFertilizationStore.LoadNFertilizationPlanningSummaries();
      this.nFertilizationStore.LoadLogfiles();
    }));
    this.statisticStore.removeStatisticData();
    this.statisticStore.setStatisticData([], ApStatsType.NFertilizationLogfileStats, '', 'Admin_Pages__Overview');
    this._gridBuilder();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe((items) => {
      this.fieldStore.changeSelectedField(items.map((item) => item.Id));
    }));
    this._subscriptions.push(combineLatest([
        this.dynComponent.gridSubject,
        this.formStore.FormClose$
      ]).pipe(filter(([grid]) => !!grid))
        .subscribe(([grid]) => grid.gridPaging.setSelectedKeys(this.fieldStore.getSelectedFieldIds()))
    );
    this._subscriptions.push(this._applyClicked.subscribe((e) => this._onApplyClicked(e)));
    this._subscriptions.push(this.fieldStore.Listen(x => x.fieldCropsSaved)
      .subscribe(x => this._invokeWhenFieldCropsUpdated(x)));
    this.burgerMenuStore.addControl('Global__NitrogenFertilization', NFertilizationBurgerMenuComponent);
  }

  public ngOnDestroy(): void {
    this.burgerMenuStore.removeControl('Global__NitrogenFertilization');
    this._subscriptions.forEach((s) => s.unsubscribe());
    this.fieldStore.changeSelectedField([]);
    this.showPointsOnMap.clear();
    this.statisticStore.removeStatisticData();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.nLogInterpolationLegend);
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
  }

  public onCreate(): void {
    this.statisticStore.removeStatisticData();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.nLogInterpolationLegend);
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
    this.formStore.openForm({
      component: ApNFertilizationPlanningEntryComponent, data: {
        Summary: undefined,
        Type: PlanningEntryComponentDataType.Create
      }
    });
  }

  private _gridBuilder(): void {
    this.loading$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.cropApplicationStore.Listen(s => s.loading),
      this.nFertilizationStore.Listen(s => s.loading),
      this.nFertilizationStore.Listen(s => s.logfilesLoading),
      this.nFertilizationStore.Listen(s => s.planBooksLoading),
      this.cropRotationStore.Listen(s => s.historyLoading)
    ]).pipe(
      map((loadings) => loadings.some(l => !!l))
    );

    this._subscriptions.push(combineLatest([
      this.fieldStore.Listen(s => s.data),
      this.cropRotationStore.Listen(s => s.history),
      this.campaignYear.Listen(s => s.selectedYear),
      this.nFertilizationStore.Listen(s => s.planBooks),
      this.nFertilizationStore.Listen(s => s.logfiles),
      this.basicFertilisationSummariesStore.Summaries$,
      this.nFertilizationStore.GetNeeds$(this.campaignYear.getSelectedCampaignYear()?.Year),
      this.cropApplicationStore.Listen(s => s.data)
    ]).pipe(
      filter(([fields, cropRotation, _1, _2, _3, _4, _5, cA]) => (fields?.length ?? 0) !== 0 && Object.keys(cropRotation).length !== 0 && cA.length !== 0),
      map(([fields, cropRotation, campaignYear, planBooks, logfiles, bfSummaries, needs, _1]) => fields.filter((field) => !!field).map((field) => {
        const geom = this.fieldStore.getCurrentFieldGeom(field);
        const crop = cropRotation[field.Id as string][campaignYear?.Year] ?? null;
        const baseFertPlanBooks = bfSummaries.map(x => x.BasicFertilisationPlanBooks).flat();
        const applications = this.nFertilizationCommonService.getContentNPlanBooks(field, planBooks, logfiles, baseFertPlanBooks);
        const fieldApplications = this.componentService.getFieldApplicationRateValues(field, planBooks, logfiles, baseFertPlanBooks);
        const mainCropDescription = this.cropTypeStore.getDefaultCroptype(crop?.MainCrop)?.Description;
        const fieldCrop = mainCropDescription ? this.cropService.getFieldCrop(field) : null;
        const nApplied = this._calculateAlreadyApplied(applications);
        return {
          Id: field.Id,
          Status: 1,
          StatusClass: 'ap-status-green',
          StatusDesc: '',
          FieldCrop: fieldCrop,
          Nr: field.FieldNumber,
          SNr: field.FieldSubnumber,
          NrSNr: this.fieldStore.getFieldNumberAndSubNumber(field),
          Name: field.FieldName,
          Area: Create(geom?.AreaHa, 0),
          Crop: mainCropDescription,
          EcValue: fieldCrop?.EcValue,
          CropNote: fieldCrop?.Note,
          Sum: '-',
          Need: needs.Find((n) => n.FieldId === field.Id)?.Value ?? '-',
          Total: '-',
          N0: fieldApplications[0],
          Scan: fieldApplications[1],
          N1: fieldApplications[2],
          N2: fieldApplications[3],
          N3: fieldApplications[4],
          N4: fieldApplications[5],
          NApplied: nApplied,
          Applications: applications,
        };
      }))
    ).subscribe((items) => {
      this.items$.next(items);
      if (!this._afterUpdateProcess) {
        this.statisticStore.setStatisticData(items, ApStatsType.Planning, '');
        this._showLatestRaster(items.map((i) => i.Applications).flat());
      } else {
        this._afterUpdateProcess = false;
      }
    }));

    this.columns$ = this.settingsStore.Listen(s => s.data).pipe(
      map((settings) => settings[0]),
      filter((setting) => !!setting),
      map(() => [
        new ApDynGridStatusColumnConfig({
          field: 'Status',
          class: 'StatusClass',
          description: 'StatusDesc',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: 'Nr',
          hide: true,
          width: 40,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldPartShort',
          field: 'SNr',
          hide: true,
          width: 40,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: 'NrSNr',
          width: 75,
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          }),
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Name',
          field: 'Name',
          cssClass: 'left',
          width: 180,
          filterable: true,
          sortIndex: 0,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: 'Area',
          width: 40,
          filterable: true,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          template: PropertyTemplate.NUMBER,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: 'Crop',
          width: 100,
          filterable: true,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'ECStageShort',
          field: 'EcValue',
          hide: true,
          width: 40,
          cssClass: 'right',
          filterable: true,
          headerFilterable: true,
          filterType: FilterType.NUMBER
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Fieldcrop_Notes',
          field: 'CropNote',
          tooltip: (item: any) => this.tooltipContentService.generateCropNoteTooltip(item['CropNote']),
          hide: true,
          width: 100,
          filterable: true,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__N0',
          field: 'N0',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Scan',
          field: 'Scan',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__N1',
          field: 'N1',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__N2',
          field: 'N2',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__N3',
          field: 'N3',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__N4',
          field: 'N4',
          checkbox: true,
          hide: true,
          width: 20,
          filterable: false
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'NApplied',
          title: 'Nutrients__already_applied',
          headerExtraLines: ['[kg N / ha]'],
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          template: PropertyTemplate.NUMBER,
          filterable: true,
          hide: true,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [0, {ToReplace: [0], ReplaceWith: ''}]
          }]
        })
      ]));
    this.details$ = combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data)
    ]).pipe(
      filter(([, settings]) => settings.length !== 0),
      map(([language]) =>
        new ApDynGridDetailsGridConfig({
          field: 'Applications',
          checkboxDisabled: true,
          hide: (dataItem) => dataItem.Applications.length === 0,
          columns: [
            new ApDynGridStatusColumnConfig({
              field: 'Status',
              class: 'StatusClass',
              description: 'StatusDesc',
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Product',
              field: 'ProductName',
              headerFilterable: true,
              width: 100,
              filterable: true,
              tooltip: (dataItem: INFertilizationOverviewGridDetailsItem) => this.tooltipContentService.getProductContentInfoTooltip(dataItem.ProductId)
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global_Application_Date',
              field: 'MidnightDate',
              format: language.DateFormat,
              sortIndex: 0,
              sortDesc: true,
              filterable: true,
              width: 80
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__N_ApplNum',
              field: 'Administration',
              filterable: true,
              width: 70,
              pipes: [{
                pipe: this.translationPipe,
                args: []
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__ECStageShort',
              field: 'EC',
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              width: 60
            }),
            new ApDynGridGroupColumnConfig({
              title: 'N__ChartTitleX',
              width: 225,
              hide: true,
              groupColumns: [
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Avg_Symbol',
                  field: 'Absorption.Avg',
                  width: 75,
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Min',
                  field: 'Absorption.Min',
                  width: 75,
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Max',
                  field: 'Absorption.Max',
                  width: 75,
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                })
              ]
            }),
            new ApDynGridGroupColumnConfig({
              title: 'Global__Nsensor_Unit',
              width: 225,
              hide: true,
              groupColumns: [
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Avg_Symbol',
                  field: 'Fertilization.Avg',
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Min',
                  field: 'Fertilization.Min',
                  width: 75,
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Max',
                  field: 'Fertilization.Max',
                  width: 75,
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                })
              ]
            }),
            new ApDynGridGroupColumnConfig({
              title: this.halfViewMode$.pipe(map((m) => m === 0 ? 'N__ChartTitleX' : 'Global__Nsensor_Unit')),
              hide: new ApDynGridColumnHideConfig({
                mapHide: false,
                selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
              }),
              headerButtons: {
                nextClicked: this.halfViewModeChange,
                previousClicked: this.halfViewModeChange,
                nextDisabled: of(false),
                previousDisabled: of(false)
              },
              xlsExport: false,
              width: 225,
              groupColumns: [
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Avg_Symbol',
                  field: 'Absorption.Avg',
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 1))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Min',
                  field: 'Absorption.Min',
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 1))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Max',
                  field: 'Absorption.Max',
                  cssClass: 'right',
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 1))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Avg_Symbol',
                  field: 'Fertilization.Avg',
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 0))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Min',
                  field: 'Fertilization.Min',
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 0))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                }),
                new ApDynGridPropertyColumnConfig({
                  title: 'Global__Max',
                  field: 'Fertilization.Max',
                  cssClass: 'right',
                  dynCssClass: (dataItem) => this.componentService.applyAdditionalStylesForFertilizationValues(dataItem),
                  tooltip: (dataItem) => this.componentService.tooltipForFertilizationValues(dataItem),
                  filterType: FilterType.NUMBER,
                  filterable: true,
                  width: 75,
                  hide: new ApDynGridColumnHideConfig({
                    mapHide: false,
                    selfHide: this.halfViewMode$.pipe(map((m) => m === 0))
                  }),
                  pipes: [{
                    pipe: this.roundNumericPipe,
                    args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                  }]
                })
              ]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Sum_Goods',
              field: 'ProductTotal',
              hide: true,
              width: 90,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              filterable: true,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: '',
              field: 'ProductTotalUnit',
              width: 50,
              hide: true
            }),
            new ApDynGridEditColumnConfig({
              data: [
                {
                  text: 'Global__RateView',
                  callback: ApUtilService.createEventEmitter(this._clickToShowOnMap.bind(this), this._subscriptions),
                  disabled: (dataItem) => !this._isRasterStatisticDataPresent(dataItem)
                },
                {
                  text: 'Global__SingleFieldView',
                  callback: ApUtilService.createEventEmitter(this._onShowSingleViewAndStatistics.bind(this), this._subscriptions),
                  disabled: (dataItem) => !this._isRasterStatisticDataPresent(dataItem)
                }
              ]
            })
          ]
        })
      )
    );
    this.pager = new ApDynGridPagerConfig({
      apply: this._applyClicked,
      listMassEditing: [
        {
          id: FieldMassEditAction.EditMainCrop,
          type: ApGridPagerType.None,
          name: this.translationService.translate('Global__Edit'),
          onSubmit: this._applyClicked,
          formConfig: [
            new ApDynformsConfigFieldset({
              key: 'OverviewDetailsFieldSet',
              config: [
                new ApDynformsConfigNumerictextbox({
                  key: 'EcValueToUpdate',
                  label: 'ECStageShort',
                  min: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MIN'),
                  max: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MAX'),
                  decimals: 0,
                  format: 'n0',
                  validators: [
                    new ApDynformsValidator({validator: Validators.required, errorKey: ''})
                  ]
                }),
                new ApDynformsConfigPlaceholder()
              ]
            })
          ]
        } as IDynGridWizardChoiceData
      ],
      iconButtons: [
        {
          icon: ApIcons.PDF,
          callback: ApUtilService.createEventEmitter(this._onPdf.bind(this), this._subscriptions),
          tooltip: 'Global__Save_PDF'
        },
        {
          icon: ApIcons.XLS,
          callback: ApUtilService.createEventEmitter(this._onXls.bind(this), this._subscriptions),
          tooltip: 'Global__Save_EXCEL'
        }
      ]
    });
  }

  private _onApplyClicked(event: IGridPagerData): void {
    if (!event) {
      return;
    }
    if (event.object.id === NFertilizationOverviewMassEditAction.Edit) {
      const selectedFieldCrops = this.dynComponent.getSelectedItems()
        .filter(x => x['FieldCrop'])
        .map(x => x['FieldCrop'] as IFieldCrop);
      if (!selectedFieldCrops || selectedFieldCrops.length <= 0) {
        return;
      }
      const copiedFieldCrops = ObjectFactory.Copy(selectedFieldCrops);
      copiedFieldCrops.forEach(fieldCrop => {
        fieldCrop.EcValue = event.value ?? event.form['EcValueToUpdate'];
      });
      this.fieldStore.saveFieldCrops(copiedFieldCrops);
    }
  }

  private _invokeWhenFieldCropsUpdated(isUpdated: boolean | undefined): void {
    if (isUpdated === undefined) {
      return;
    }
    this._afterUpdateProcess = true;
    if (isUpdated) {
      this.notifyStore.showSaveSuccessMessage();
    } else {
      this.notifyStore.showSaveFailMessage();
    }
  }

  private _onShowSingleViewAndStatistics(dataItem: INFertilizationOverviewGridDetailsItem): void {
    if (!dataItem) {
      return;
    }
    if (!!dataItem.FieldId && !!dataItem.PlanBookId) {
      this.showPointsOnMap.showRaster(dataItem.FieldId.toString(), dataItem.PlanBookId.toString(), 'nd');
    }
    const dataCollection: NFertilizationLogfileStatsData[] = [];
    if (!!dataItem.PlanBookId) {
      const logFiles = this.nFertilizationStore.Logfiles?.filter(x => x.Status === 1 && !!x.NPlanBook?.Id && x.NPlanBook?.Id === dataItem.PlanBookId) ?? [];
      if (logFiles.length > 0) {
        const planBook = this.nFertilizationStore.PlanBooks.find(x => x.Id === dataItem.PlanBookId);
        const data: NFertilizationLogfileStatsData = {
          PlanBookId: planBook.Id,
          Area: dataItem.WorkArea,
          Logfiles: logFiles,
          RasterStatistics: planBook.RasterStatistics
        };
        dataCollection.push(data);
      }
    }
    this.statisticStore.removeStatisticData();
    this.statisticStore.setStatisticData(dataCollection, ApStatsType.NFertilizationLogfileStats, undefined);
    if (this.mapViewStore.getMapViewMode() !== MapViewMode.NORMAL) {
      this.mapViewStore.showMapView();
    }
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.MAP) {
      this.mapViewStore.goIntoMapMenu();
    }
    if (!!dataItem.FieldId) {
      this._selectItemsForGrid([dataItem.FieldId.toString()]);
    }
  }

  private _showLatestRaster(applications: INFertilizationOverviewGridDetailsItem[]): void {
    const filtered = applications.filter((a) => a.CropKey != null);
    const max = filtered.map((a) => a.Date.valueOf()).Max();
    this._onShowAll(filtered.Find((application) => application.Date.valueOf() === max));
  }

  private _isRasterStatisticDataPresent(dataItem: INFertilizationOverviewGridDetailsItem): boolean {
    if (!dataItem) {
      return false;
    }
    const planBook = this.nFertilizationStore.PlanBooks.find(x => x.Id === dataItem.PlanBookId);
    const rasterStatistic = planBook?.RasterStatistics ?? [];
    return rasterStatistic.length > 1 && (!!rasterStatistic[0] || !!rasterStatistic[1]);
  }

  private _calculateAlreadyApplied(detailsItems: INFertilizationOverviewGridDetailsItem[]): number | undefined {
    if (!detailsItems || detailsItems.length <= 0) {
      return undefined;
    }
    return detailsItems.reduce((total, currentItem) => total + currentItem.AlreadyApplied, 0);
  }

  private _clickToShowOnMap(dataItem: INFertilizationOverviewGridDetailsItem): void {
    if (!dataItem) {
      return;
    }
    this._onShowAll(dataItem);
    this.mapStore.Layers.NRaster.zoomToExtent();
  }

  private _onShowAll(dataItem: INFertilizationOverviewGridDetailsItem): void {
    if (!dataItem) {
      return;
    }
    if (this.showPointsOnMap.isActive(dataItem.FieldId.toString(), dataItem.PlanBookId.toString())) {
      this.showPointsOnMap.showRaster(dataItem.FieldId.toString(), dataItem.PlanBookId.toString(), 'nd');
      return;
    }
    const applicationMap: { [fieldId: string]: any } = {[dataItem.FieldId.toString()]: dataItem};
    this.items$.value
      .map((item) => item.Applications as INFertilizationOverviewGridDetailsItem[])
      .flat()
      .filter((application) => application.FieldId !== dataItem.FieldId
        && application.CropKey === dataItem.CropKey && application.Application === dataItem.Application
        && application.Administration === dataItem.Administration)
      .forEach((other: INFertilizationOverviewGridDetailsItem) => {
        const fieldId = other.FieldId.toString();
        if (applicationMap[fieldId] !== undefined) {
          if (other.Date.valueOf() > applicationMap[fieldId].Date.valueOf()) {
            applicationMap[fieldId] = other;
          }
        } else {
          applicationMap[fieldId] = other;
        }
      });
    this.showPointsOnMap.showAllRaster(Object.values(applicationMap), 'nd');
  }

  private _selectItemsForGrid(fieldIds: IGuid[]): void {
    if (!fieldIds) {
      return;
    }
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys(fieldIds);
    this.fieldStore.changeSelectedField(fieldIds.map(x => x.toString()));
  }

  private _onPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private _onXls(): void {
    this.dynComponent.dynGrid.xlsExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsXls();
  }

  private _generatePrintFilename(): string {
    return `${this.dateService.toFarmDate(new Date()).format('YYYY-MM-DD')}_` +
      `${this.translationService.translate('Global__NitrogenFertilization')}_` +
      `${this.translationService.translate('Admin_Pages__Overview')}`;
  }

  public isCreateNewAllowed(): boolean {
    return ApRoleTypeService.hasDeveloperRole(this.loginStore.User);
  }
}
